import { EditorHTML } from '@duke-hq/ui/components/DukeTiptapEditor/EditorHTML';
import { SlideKind } from '@duke-hq/svc-api-db';
import type { FormattedSlide } from './types';

export function SlideContent({ slide }: { slide: FormattedSlide }) {
  const showsQuestionContent =
    slide.kind === SlideKind.OPEN_QUESTION || slide.kind === SlideKind.FILE_UPLOAD_PROMPT;
  const content = showsQuestionContent ? slide.question?.questionContent : undefined;

  return content ? <EditorHTML content={content} style={{ padding: 0 }} /> : null;
}
